import { User } from "firebase/auth";
import { HouseName } from "../ostertalertypes";

export interface AdminClaims {
  admin: boolean;
  houses?: HouseName[];
  accessLevel?: number;
}

/**
 * Get admin claims from the user's ID token.
 * @param user The Firebase user
 * @returns Admin claims or null if user is not an admin
 */
export async function getAdminClaims(user: User): Promise<AdminClaims | null> {
  try {
    const tokenResult = await user.getIdTokenResult();
    if (tokenResult.claims.admin === true) {
      return {
        admin: true,
        houses: tokenResult.claims.houses as HouseName[] || [],
        accessLevel: tokenResult.claims.accessLevel as number || 0,
      };
    }
  } catch (error) {
    console.error("Error retrieving admin claims:", error);
  }
  return null;
}

/**
 * Check if an admin has access to a specific house.
 * @param adminHouses Array of houses the admin has access to
 * @param houseName The house to check access for
 * @returns True if admin has access to the house
 */
export function hasAccessToHouse(adminHouses: HouseName[] | undefined, houseName: string): boolean {
  if (!adminHouses || adminHouses.length === 0) {
    return false;
  }
  return adminHouses.includes(houseName as HouseName);
}

/**
 * Filter reservations to only include those from houses the admin has access to.
 * @param reservations Array of reservations
 * @param adminHouses Array of houses the admin has access to
 * @returns Filtered reservations
 */
export function filterReservationsByAdminHouses(
  reservations: any[],
  adminHouses: HouseName[] | undefined
): any[] {
  if (!adminHouses || adminHouses.length === 0) {
    return [];
  }
  return reservations.filter(res => adminHouses.includes(res.houseName as HouseName));
}
